import { useContext, useEffect, useState } from "react";
import { haveValue, toast } from "../../helper/common";
import { useNavigate, useParams } from "react-router-dom";
import backicon from "../../assets/img/back.png";
import useTranslator from "../../hooks/useTranslator";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import CandidateSummary from "./CandidateSummary";
import axiosInstance from "../../services/authWrapper";
import TenantContext from "../../context/tenant/TenantContext";
import SkorList2 from "../tenant-profile/skorList2";
import Loader from "../../components/Loader";

const ReportWrapper = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { getPropertyDetails, fetchingCreatedTenant } =
    useContext(LandLordContext);
  const { fetchTenantDocs } = useContext(TenantContext);
  const {
    user: originalUser,
    checkIeDetails,
    loadUser,
  } = useContext(AuthContext);
  const queryParameters = new URLSearchParams(window.location.search);
  const definedRent = queryParameters.get("rent") ?? 0;
  const sharedprofileid = queryParameters.getAll("sharedprofileid");
  const agencylink = queryParameters.getAll("agencylink");
  const guarantor_id = queryParameters.get("guarantor_id");
  const llCreated = queryParameters.get("llCreated") === "true";
  const property_id = queryParameters.get("property");
  const redirectUrl = queryParameters.get("redirectUrl");
  const [addressVal, setAddressVal] = useState("");
  const [combinedMaxRent, setCombinedMaxRent] = useState(0);
  const [combinedEffortRate, setCombinedEffortRate] = useState(0);
  const [userIncomes, setUserIncomes] = useState({});
  const [userMaxRent, setUserMaxRent] = useState({});
  const [localLoading, setLocalLoading] = useState(true);

  const { id } = useParams();

  const [ids, setIds] = useState([]);
  const [type, setType] = useState(null);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const temp_vals = Object.values(userMaxRent);
    let temp_max_rent = 0;
    temp_vals.map((val) => (temp_max_rent += +val));
    setCombinedMaxRent(temp_max_rent);
  }, [userMaxRent]);

  useEffect(() => {
    setLocalLoading(true);
    let userType = localStorage.getItem("usertype");
    loadUser(userType);

    if (haveValue(sharedprofileid[0])) {
      setIds(sharedprofileid);
      setType("sharedprofileid");
    } else if (haveValue(agencylink[0])) {
      setIds(agencylink);
      setType("agencylink");
    } else if (llCreated) {
      setIds([id]);
      setType("llCreated");
    } else {
      setIds([id]);
    }
    if (haveValue(property_id)) {
      getPropertyDetails(property_id)
        .then((res) => {
          const data = res.properties;
          setAddressVal(
            `${data?.street ?? ""}, ${data?.street_number ?? ""}, ${
              data?.floor_number ?? ""
            }-${data?.flat_number ?? ""}, ${data?.postcode ?? ""}, ${
              data?.muncipality ?? ""
            }, ${data?.province ?? ""}`
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  useEffect(() => {
    setCombinedEffortRate(
      Math.ceil((definedRent / combinedMaxRent ?? 1) * 100)
    );
    setLocalLoading(false);
  }, [combinedMaxRent]);

  const printDocument = () => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      printDocumentSafari();
    } else {
      printDocumentSafari();
    }
  };

  function isPathActive(path) {
    if (!path) return false;

    const fill = path.style.fill || path.getAttribute("fill");
    const inactiveFills = [
      "rgb(238, 238, 238)",
      "rgba(0, 0, 0, 0)",
      "#eeeeee",
      "transparent",
      "none",
      "", // empty string (some browsers)
    ];

    return !inactiveFills.includes(fill?.trim().toLowerCase());
  }

  const printDocumentSafari = async () => {
    const container = document.getElementById("divToPrint");
    const children = Array.from(container.children);

    try {
      // A4 in points (1pt = 1/72 inch)
      const A4_WIDTH = 595.28; // portrait width
      const A4_HEIGHT = 841.89; // portrait height

      // Always create PDF as A4 portrait
      let pdf = new jsPDF({
        orientation: "p",
        unit: "pt",
        format: "a4",
      });

      for (let i = 0; i < children.length; i++) {
        let nodeToRender;

        if (i === 0 && children.length >= 2) {
          const wrapper = document.createElement("div");
          wrapper.style.display = "block";
          wrapper.appendChild(children[0].cloneNode(true));
          wrapper.appendChild(children[1].cloneNode(true));
          document.body.appendChild(wrapper);
          nodeToRender = wrapper;
        } else if (i === 1) {
          continue; // skip second child (merged above)
        } else {
          nodeToRender = children[i];
        }

        // Render DOM to canvas
        const canvas = await html2canvas(nodeToRender, {
          useCORS: true,
          backgroundColor: "#ffffff",
          scale: 2, // higher scale for sharpness
        });

        const imgData = canvas.toDataURL("image/jpeg", 0.95);

        // Original element size
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        // Scale image to fit into A4 portrait
        const scale = Math.min(A4_WIDTH / imgWidth, A4_HEIGHT / imgHeight);

        const renderWidth = imgWidth * scale;
        const renderHeight = imgHeight * scale;

        // Center horizontally, top-align vertically
        const x = (A4_WIDTH - renderWidth) / 2;
        const y = 0;

        // Add page if not first
        if (i > 0) pdf.addPage("a4", "p");

        pdf.addImage(imgData, "JPEG", x, y, renderWidth, renderHeight);

        if (i === 0 && children.length >= 2) {
          document.body.removeChild(nodeToRender);
        }
      }

      // Save with your logic
      if (haveValue(property_id)) {
        pdf.save(`${addressVal}.pdf`);
      } else {
        let temp_user = allUsers[0];
        let user_data = haveValue(temp_user?.tenantid)
          ? temp_user?.tenantid
          : temp_user;

        if (
          haveValue(guarantor_id) &&
          Array.isArray(user_data?.gurantor_id) &&
          user_data?.gurantor_id?.length
        ) {
          const guarantor = user_data.gurantor_id.find(
            (u) => u._id?.toString() === guarantor_id
          );
          if (guarantor) user_data = guarantor;
        }

        const fileName =
          allUsers.length > 1
            ? "Skor Profiles"
            : `${user_data?.fname || ""} ${user_data?.lname || ""}`.trim();

        pdf.save(`${fileName}.pdf`);
      }
    } catch (err) {
      console.error("Error capturing element:", err);
    }
  };

  const [sharedProfileInfo, setSharedProfileInfo] = useState(null);
  const fetchUserById = async (id, type) => {
    try {
      if (llCreated) {
        const res = await fetchingCreatedTenant(id);
        const doc_data = await fetchFileData(res?.data?._id);
        res.data.doc_data = doc_data;
        return res.data;
      }

      const landlordId = localStorage.getItem("saveduserid");
      const lang = localStorage.getItem("i18nextLng");
      const headers = { "Accept-Language": lang };

      let url = "";

      if (type === "sharedprofileid") {
        url = `${process.env.REACT_APP_SERVER_URL}/shared-profile/singleshared/${id}?landlordId=${landlordId}`;
      } else if (type === "agencylink") {
        url = `${process.env.REACT_APP_SERVER_URL}/shared-profile/agency-shared/${id}?landlordId=${landlordId}`;
      } else {
        return originalUser;
      }

      const res = await axiosInstance.get(url, { headers });

      const user = res.data.singleSharedProfile;
      if (type === "sharedprofileid") {
        user.tenant_id = user?.tenantid;
      }
      setSharedProfileInfo(user);

      if (user?.tenantid?.ie_details_id) {
        user.tenantid.ie_verified = checkIeDetails(user.tenantid);
      }

      const doc_data = await fetchFileData(user?.tenantid?._id);
      user.tenantid.doc_data = doc_data;
      return user;
    } catch (err) {
      if (err?.response?.data?.key === "insufficientCredits") {
        toast.error(_t(err?.response?.data?.key));
        navigate(-1);
      }
      console.error("Error fetching user by ID:", err);
      return null;
    }
  };

  const fetchFileData = async (user_id) => {
    const res = await fetchTenantDocs(user_id, llCreated);
    const tenantDocsData = res.data.success_res.tenantDocs;
    if (haveValue(tenantDocsData) && tenantDocsData.length >= 1) {
      const temp_arr = new Map();
      tenantDocsData.map((docs) => {
        temp_arr.set(docs?.type + (docs?.year ? docs?.year : ""), docs);
      });

      return Array.from(temp_arr.values());
    }
    return [];
  };

  const fetchAllUsersInOrder = async (ids, type) => {
    setLocalLoading(true);
    const promises = ids.map((id) => fetchUserById(id, type));
    const users = await Promise.all(promises);

    setAllUsers(users.filter((user) => user !== null));
    setLocalLoading(false);
  };

  useEffect(() => {
    if (Array.isArray(ids) && ids.length > 0) {
      fetchAllUsersInOrder(ids, type);
    }
  }, [originalUser, ids]);

  const handleBack = () => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      {localLoading ? (
        <Loader />
      ) : (
        <div className="tabs-box-pattern-2">
          <div className="tabs-item-1 d-block">
            <div className="row">
              <div className="header-edit text-center report-header space-custom d-flex items-center justify-content-between position-relative">
                <div>
                  {" "}
                  <div className="cursor-pointer" onClick={handleBack}>
                    <img src={backicon} alt="backbtn" />
                  </div>
                </div>
                <div
                  className="pdf-qrcode position-absolute"
                  style={{
                    right: "30px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <div>
                    <button
                      className="btn btngreen downloadpdf"
                      id="downloadpdf"
                      onClick={printDocument}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M4.5 0C3.25898 0 2.25 1.00898 2.25 2.25V5.625H4.5V2.25H12.4699L13.5 3.28008V5.625H15.75V3.28008C15.75 2.68242 15.5145 2.10938 15.0926 1.6875L14.0625 0.657422C13.6406 0.235547 13.0676 0 12.4699 0H4.5ZM13.5 12.375V15.75H4.5V12.375H13.5ZM15.75 13.5H16.875C17.4973 13.5 18 12.9973 18 12.375V9C18 7.75898 16.991 6.75 15.75 6.75H2.25C1.00898 6.75 0 7.75898 0 9V12.375C0 12.9973 0.502734 13.5 1.125 13.5H2.25V15.75C2.25 16.991 3.25898 18 4.5 18H13.5C14.741 18 15.75 16.991 15.75 15.75V13.5ZM15.1875 8.71875C15.4113 8.71875 15.6259 8.80764 15.7841 8.96588C15.9424 9.12411 16.0312 9.33872 16.0312 9.5625C16.0312 9.78628 15.9424 10.0009 15.7841 10.1591C15.6259 10.3174 15.4113 10.4062 15.1875 10.4062C14.9637 10.4062 14.7491 10.3174 14.5909 10.1591C14.4326 10.0009 14.3438 9.78628 14.3438 9.5625C14.3438 9.33872 14.4326 9.12411 14.5909 8.96588C14.7491 8.80764 14.9637 8.71875 15.1875 8.71875Z"
                          fill="#253837"
                        />
                      </svg>
                      {_t("downloadPDF")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div id="divToPrint" className="row">
              {haveValue(property_id) && (
                <>
                  <div className="pt-5">
                    <div className="report-main align-items-center d-flex justify-content-between">
                      <h3>{_t("candidacyReport")}</h3>
                      <img src="/images/SkorWhite.svg" alt="" />
                    </div>
                    <div className="mx-custom-gap report-header-border w-fit">
                      <div className="report-content">
                        <div className="img-comp">
                          <img
                            src="/images/house-star.svg"
                            className="house-start-img"
                            alt="icon"
                          />
                          <div className="d-flex flex-column padd-3px">
                            <span className="pdf-upr-stripe-label">
                              {_t("address")}
                            </span>
                            <span className="pdf-upr-stripe-value nowrap-text">
                              {addressVal}
                            </span>
                          </div>
                        </div>

                        <div className="d-flex flex-column padd-3px">
                          <span className="pdf-upr-stripe-label">
                            {_t("rentPriceReport")}
                          </span>
                          <span className="pdf-upr-stripe-value">
                            {definedRent}€
                          </span>
                        </div>

                        <div className="d-flex flex-column padd-3px">
                          <span className="pdf-upr-stripe-label">
                            {" "}
                            {_t(
                              "combinedSalary",
                              "while generating report for multi tenants"
                            )}
                          </span>
                          <div className="d-flex gap-20px">
                            <span className="pdf-upr-stripe-value">
                              {parseFloat(combinedMaxRent.toFixed(2))}€
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="candidate-details candidateDetails">
                    <div className="mx-custom-gap p-0">
                      <>
                        <CandidateSummary
                          allUsers={allUsers}
                          definedRent={definedRent}
                        />
                      </>
                    </div>
                  </div>
                </>
              )}
              {ids.map((id) => (
                <div className="pt-0">
                  <div className="d-flex justify-content-center pb-3">
                    <img
                      src="/images/SkorWhite.svg"
                      alt=""
                      // style={{ margin: "0.972vw" }}
                    />
                  </div>
                  <SkorList2
                    sharedprofileid={type == "sharedprofileid" ? id : null}
                    agencylink={type == "agencylink" ? id : null}
                    guarantor={guarantor_id ?? null}
                    setUserMaxRent={setUserMaxRent}
                    setUserIncomes={setUserIncomes}
                    showReportIcons={false}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportWrapper;
